import { useLayoutEffect, useRef, useState, type ReactNode } from "react";

/**
 * Só monta o gráfico quando o container já tem width/height > 0.
 * Evita o warning do Recharts: width(-1) and height(-1).
 */
export function ResponsiveChartFrame({
  className,
  children,
}: {
  className?: string;
  children: (size: { width: number; height: number }) => ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<{ width: number; height: number } | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      const { width, height } = el.getBoundingClientRect();
      const w = Math.round(width);
      const h = Math.round(height);
      setSize((prev) => {
        if (w <= 0 || h <= 0) return null;
        if (prev && prev.width === w && prev.height === h) return prev;
        return { width: w, height: h };
      });
    };

    measure();
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} className={className}>
      {size ? children(size) : null}
    </div>
  );
}
